import { render } from "./FormDate.vue?vue&type=template&id=ca90b1d2&scoped=true"
import script from "./FormDate.vue?vue&type=script&lang=js"
export * from "./FormDate.vue?vue&type=script&lang=js"

import "./FormDate.vue?vue&type=style&index=0&id=ca90b1d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca90b1d2"]])

export default __exports__